import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

function ScrollToTop({ location }) {
  useEffect(() => {
    const mainPanel = document.querySelector(".main-panel");
    if (mainPanel) {
      mainPanel.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
}

ScrollToTop.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(ScrollToTop);